import React from 'react';
import {
  FormControl, InputLabel, Select, MenuItem, Stack, Typography, Box
} from '@mui/material';
import AppCard from '../common/AppCard';
import TuneIcon from '@mui/icons-material/Tune';
import { usePreference } from '../../hooks/usePreference';

// Each preference here is wired to real behaviour elsewhere in the app —
// landing page is consumed by the router in App.js, week start by the
// Calendar view.
const LANDING_OPTIONS = [
  { value: '/dashboard', label: 'Overview' },
  { value: '/transactions', label: 'Transactions' },
  { value: '/calendar', label: 'Calendar' },
  { value: '/cashflow', label: 'Cashflow' },
  { value: '/networth', label: 'Net Worth' },
  { value: '/budgets', label: 'Budgets' },
];

function PreferenceRow({ label, helper, children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
        gap: { xs: 1, sm: 2 },
      }}
    >
      <Box sx={{ minWidth: { sm: 200 }, flex: 1 }}>
        <Typography variant="body2" fontWeight={600}>{label}</Typography>
        {helper && (
          <Typography variant="caption" color="text.secondary">{helper}</Typography>
        )}
      </Box>
      <Box sx={{ width: { xs: '100%', sm: 220 }, flexShrink: 0 }}>{children}</Box>
    </Box>
  );
}

// Open below the field like a plain dropdown instead of MUI's default
// selected-item alignment, which climbs up and covers the row's label.
const SELECT_MENU_PROPS = {
  variant: 'menu',
  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
  transformOrigin: { vertical: 'top', horizontal: 'left' },
};

export default function PreferencesCard() {
  const [landingPage, setLandingPage] = usePreference('defaultLandingPage', '/dashboard');
  const [weekStart, setWeekStart] = usePreference('weekStart', 'monday');

  return (
    <AppCard title="Preferences" icon={<TuneIcon />}>
      <Stack spacing={2.5}>
        <PreferenceRow
          label="Start page"
          helper="Where the app opens after you log in"
        >
          <FormControl fullWidth size="small">
            <Select value={landingPage} onChange={e => setLandingPage(e.target.value)} MenuProps={SELECT_MENU_PROPS}>
              {LANDING_OPTIONS.map(o => (
                <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </PreferenceRow>

        <PreferenceRow
          label="Week starts on"
          helper="First column of the Calendar view"
        >
          <FormControl fullWidth size="small">
            <Select value={weekStart} onChange={e => setWeekStart(e.target.value)} MenuProps={SELECT_MENU_PROPS}>
              <MenuItem value="monday">Monday</MenuItem>
              <MenuItem value="sunday">Sunday</MenuItem>
            </Select>
          </FormControl>
        </PreferenceRow>
      </Stack>
    </AppCard>
  );
}
